import creditReducer, { creditAdapter, creditSlice } from './reducer';

const creditSelectors = {
  ...creditAdapter.getSelectors(),
};

const creditActions = {
  ...creditSlice.actions,
};

export { creditActions, creditReducer, creditSelectors };
